import React, { Component } from 'react';
import Checkbox from 'material-ui/Checkbox';
import UnCheckedIcon from 'material-ui/svg-icons/toggle/check-box-outline-blank';
import HelpTooltip from '../../controls/helpTooltip';

export default class CheckBox extends Component {
    
    toggleCheckbox = () => {
        
        this.props.onCheck(this.props.dataKey);
    }
    
    render() {

        const styles = {
            icon: {
                fill: '#373050',
                width: 20,
                height: 20,
                marginRight: 10
            }
        };
        
        return (
            <div
                className='portal-checkbox-wrapper'
                
            >
                <div>
                    <Checkbox
                        checked={this.props.checked}
                        onCheck={this.toggleCheckbox}
                        iconStyle={styles.icon}
                        disabled={this.props.disabled}
                        uncheckedIcon={<UnCheckedIcon style={{
                            fill: '#D5D5D5'
                        }} />}
                        data-cy={this.props.dataCy}
                    />
                </div>
                
                <div className={`text${this.props.disabled ? ' disabled' : ''}`}>
                    {this.props.label}
                </div>
            
                {
                    this.props.helpTooltipText != undefined 
                            ? <div><HelpTooltip text={this.props.helpTooltipText} /></div> : null
                }
                
            </div>
        );
    }
}